import { apiCall } from "@/core/api";

/**
 * Whether the Data Store + (Baserow) tier is enabled for the current organization.
 * <p>
 * The endpoint sits on the tier-neutral organization-datastore controller, but it resolves
 * {@code DataStoreProviderType.BASEROW} specifically, so it answers for Data Store + only — not for
 * the in-house tier. The path is a released contract and does not move with this file's name.
 */
export async function isDataStorePlusEnabled(): Promise<boolean> {
  try {
    const response = await apiCall(
      "GET",
      "/organization-datastore/is-datastore-enabled"
    );
    return response?.result === true;
  } catch (error) {
    console.warn("Failed to check Data Store Plus visibility:", error);
  }
  return false;
}
